"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _toolbar = require("../../utils/toolbar");

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  flex-shrink: 0;\n  margin-left: ", "px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledControl = _styledComponents.default.div.withConfig({
  displayName: "Control__StyledControl",
  componentId: "cf87g6-0"
})(_templateObject(), function (props) {
  return props.marginLeft;
});

var Control =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Control, _Component);

  function Control(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Control);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Control).call(this));
    _this.marginLeft = (0, _toolbar.getMarginLeft)(props.prevControlType || null);
    return _this;
  }

  (0, _createClass2.default)(Control, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var controlRect = this.props.controlRect;

      if (this.el && typeof controlRect === 'function') {
        var domRect = this.el.getBoundingClientRect();
        controlRect({
          width: domRect.width,
          marginLeft: this.marginLeft
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return _react.default.createElement(StyledControl, {
        marginLeft: this.marginLeft
      }, _react.default.createElement("div", {
        ref: function ref(el) {
          return _this2.el = el;
        }
      }, this.props.children));
    }
  }]);
  return Control;
}(_react.Component);

exports.default = Control;
Control.propTypes = {
  children: _react.PropTypes.node.isRequired,
  prevControlType: _react.PropTypes.string,
  controlRect: _react.PropTypes.func
};
module.exports = exports.default;